import { h, Host } from "@stencil/core";
/**
 * The `ch-tabular-grid-column-settings` component represents a settings window for a column.
 */
export class ChTabularGridColumnSettings {
    constructor() {
        this.column = undefined;
        this.show = false;
    }
    windowClosedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.column.showSettings = false;
    }
    columnSettingsChangedHandler() {
        this.column.showSettings = false;
    }
    render() {
        return (h(Host, { key: 'd056911a2805a30381c634ba4d259170299e8483' }, h("ch-window", { key: 'aefbf27c4a15efde8cefb7fa080e392f332c9e10', modal: true, container: this.column, xAlign: "inside-start", yAlign: "outside-end", caption: this.column.columnName, closeText: "Close", closeOnOutsideClick: true, closeOnEscape: true, allowDrag: "header", hidden: !this.show, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", { key: '9da86af290d8ff64b601c98c8f66b483e4f30e38' }))));
    }
    static get is() { return "ch-tabular-grid-column-settings"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-column-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-column-settings.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChTabularGridColumnElement",
                    "resolved": "HTMLChTabularGridColumnElement",
                    "references": {
                        "HTMLChTabularGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChTabularGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The `HTMLChTabularGridColumnElement` that the settings window is associated with."
                }
            },
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings window is currently shown or not."
                },
                "attribute": "show",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get listeners() {
        return [{
                "name": "windowClosed",
                "method": "windowClosedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnSettingsChanged",
                "method": "columnSettingsChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
